<template>
  <div class="card mb-25 border-0 rounded-0 bg-white add-user-card">
    <div class="card-header">
      <h3 class="text-black fw-semibold">Modifier une créance</h3>
    </div>
    <div class="card-body p-15 p-sm-20 p-md-25 p-lg-30 letter-spacing">
      <Form ref="creanceForm" @submit="editCreance" :validation-schema="creanceSchema" :initial-values="creanceForm">
        <div class="row">
          <!-- Date de la creance (en lecture seule) -->
          <div class="col-md-4 mb-3">
            <div class="form-group mb-15 mb-sm-20 mb-md-25">
              <label class="d-block text-black fw-semibold mb-10">
                Date de la creance <span class="text-danger">*</span>
              </label>
              <Field name="dateCreance" type="date"  readonly
                class="form-control shadow-none fs-md-15 text-black" />
              <ErrorMessage name="dateCreance" class="text-danger" />
            </div>
          </div>

          <!-- Client -->
          <div class="col-md-4 mb-3">
            <div class="form-group mb-15 mb-sm-20 mb-md-25">
              <label class="d-block text-black mb-10">
                Client <span class="text-danger">*</span>
              </label>
              <Field name="client" v-model="client" type="text" v-slot="{ field }">
                <Multiselect v-model="field.value" v-bind="field" :options="clientOptions" :preserve-search="true"
                  :multiple="false" :searchable="true" placeholder="Sélectionner le client" label="label"
                  track-by="label" />
              </Field>
              <ErrorMessage name="client" class="text-danger" />
            </div>
          </div>

          <!-- Montant total du prêt -->
          <div class="col-md-4 mb-3">
            <div class="form-group mb-15 mb-sm-20 mb-md-25">
              <label class="d-block text-black fw-semibold mb-1">
                Montant total de la créance <span class="text-danger">*</span>
              </label>
              <Field type="number" name="montant" v-model="montant" class="form-control shadow-none fs-md-15 text-black" />
              <ErrorMessage name="montant" class="text-danger" />
            </div>
          </div>

          <!-- Motif de la creance et Nombre d'échéances sur une même ligne -->
          <div class="col-md-8 mb-3">
            <div class="form-group mb-15 mb-sm-20 mb-md-25">
              <label class="d-block text-black fw-semibold mb-10">
                Motif de la créance <span class="text-danger">*</span>
              </label>
              <Field name="motifCreance" cols="20" rows="1" as="textarea" placeholder="Description" v-slot="{ field }"
                class="form-control shadow-none rounded-0 text-black">
                <textarea v-model="field.value" class="form-control shadow-none rounded-0 text-black"></textarea>
              </Field>
              <ErrorMessage name="motifCreance" class="text-danger" />
            </div>
          </div>
          <div class="col-md-4 mb-3">
            <div class="form-group mb-15 mb-sm-20 mb-md-25">
              <label class="d-block text-black fw-semibold mb-1">
                Nombre d'échéances <span class="text-danger">*</span>
              </label>
              <Field type="number" name="nbreEcheance" v-model="nbreEcheance" class="form-control shadow-none fs-md-15 text-black" />
              <ErrorMessage name="nbreEcheance" class="text-danger" />
            </div>
          </div>

          <!-- Section Échéances -->
          <div v-if="nbreEcheance > 0" class="col-md-12 mb-md-25">
            <div class="tab-pane fade show active p-10" id="home-tab-pane" role="tabpanel" tabindex="0">
              <div class="row">
                <div class="border border-primary mb-10">
                  <div class="row d-flex align-items-center justify-content-between fw-bold py-2"
                    style="background-color: #0a59a4">
                    <div class="col-md-12">
                      <h3 class="fs-4 text-white">
                        Échéances
                      </h3>
                    </div>
                  </div>
                  <div>
                    <div class="row d-flex align-items-center justify-content-between mt-10">
                      <div class="col-md-4">
                        <label class="d-block text-black fw-semibold">
                          Date Échéance <span class="text-danger">*</span>
                        </label>
                      </div>
                      <div class="col-md-4">
                        <label class="d-block text-black fw-semibold mb-10">
                          Montant <span class="text-danger">*</span>
                        </label>
                      </div>
                      <div class="col-md-4">
                        <label class="d-block text-black fw-semibold mb-10">
                          Actions <span class="text-danger">*</span>
                        </label>
                      </div>
                    </div>
                    <hr class="mt-0" />
                    <div class="row" v-for="(echeance, index) in echeances" :key="index">
                      <div class="col-md-4 mb-2">
                        <div class="form-group">
                          <input v-model="echeance.dateEcheance" name="dateEcheance" type="date"
                            class="form-control shadow-none fs-md-15 text-black" placeholder="Saisir la date de l'échéance" />
                          <div class="invalid-feedback" v-if="valideteRowEcheance(echeance.dateEcheance)">
                            La date échéance est obligatoire.
                          </div>
                        </div>
                      </div>
                      <div class="col-md-4 mb-2">
                        <div class="form-group">
                          <input v-model="echeance.montant" name="montant" type="number"
                            class="form-control shadow-none fs-md-15 text-black" placeholder="Entrer le montant" />
                          <div class="invalid-feedback" v-if="valideteRowEcheance(echeance.montant)">
                            Le montant est obligatoire.
                          </div>
                        </div>
                      </div>
                      <div class="col-md-4 mb-2">
                        <button class="btn btn-danger transition border-0 pb-2 ps-8 pe-8" type="button"
                          @click="removeRowEcheance(index)">
                          <i class="fa fa-trash-o lh-1 me-1 position-relative top-2"></i>
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- Boutons -->
          <div class="col-md-12 mt-3">
            <div class="d-flex align-items-center">
              <button class="btn btn-success me-3" type="submit">
                Modifier une créance
              </button>
              <router-link to="/creances/liste-creances" class="btn btn-danger">
                <i class="fa fa-trash-o lh-1 me-1 position-relative top-2"></i>
                <span class="position-relative"></span>Annuler
              </router-link>
            </div>
          </div>
        </div>
      </Form>
    </div>
  </div>
</template>
<script lang="ts">
import { defineComponent, onMounted, reactive, ref, watch } from 'vue';
import { Form, Field, ErrorMessage } from 'vee-validate';
import * as Yup from 'yup';
import ApiService from '@/services/ApiService';
import { error, success } from '@/utils/utils';
import Multiselect from '@vueform/multiselect/src/Multiselect';
import router from '@/router';
import { useRouter, useRoute } from 'vue-router';

export default defineComponent({
  name: "EditCreance",
  components: {
    Form,
    Field,
    ErrorMessage,
    Multiselect,
  },

  setup: () => {
    // Schéma de validation pour "Demande de prêt"
    const creanceSchema = Yup.object().shape({
      dateCreance: Yup.date().required('La date de creance est obligatoire'),
      client: Yup.string().required('Le client est obligatoire'),
      montant: Yup.number().required('Le montant total est obligatoire').typeError('Veuillez entrer un nombre'),
      nbreEcheance: Yup.number().required('Le nombre d\'échéances est obligatoire').typeError('Veuillez entrer un nombre'),
      motifCreance: Yup.string().required('Le motif est obligatoire'),
    });

    // Fonction pour obtenir la date actuelle
    const getCurrentDate = () => {
      const date = new Date();
      const year = date.getFullYear();
      const month = date.getMonth() + 1;
      const day = date.getDate();
      return `${year}-${month < 10 ? `0${month}` : month}-${day < 10 ? `0${day}` : day}`;
    };

    // Variables réactives
    const clientOptions = ref([]);
    const client = ref(null);
    const montant = ref(0);
    const nbreEcheance = ref(0);
    const isDisable = ref(true);
    const creanceForm = ref(null);
    const route = useRoute();
    const router = useRouter();

    // Échéances
    const echeances = reactive([{
      dateEcheance: "",
      montant: "",
    }]);

    // Supprimer une échéance
    const removeRowEcheance = (index) => {
      if (echeances.length > 1) echeances.splice(index, 1);
    };

    // Validation des échéances
    const valideteRowEcheance = (e) => {
      return e === "" || e === "0" || e < 0;
    };

    // Surveiller les changements dans les échéances
    watch(echeances, (newValue) => {
      isDisable.value = newValue.some(
        (echeance) =>
          valideteRowEcheance(echeance.dateEcheance) ||
          valideteRowEcheance(echeance.montant)
      );
    }, { deep: true });

    // Ajuster le nombre d'échéances
    watch(nbreEcheance, (newVal) => {
      const count = parseInt(newVal.toString()) || 0;
      echeances.length = count;
      for (let i = 0; i < count; i++) {
        if (!echeances[i]) {
          echeances[i] = { dateEcheance: "", montant: "" };
        }
      }
    });

    // Charger les clients
    const getAllClients = async () => {
      try {
        const response = await ApiService.get('/all/clients');
        const clientsData = response.data.data.data;
        clientOptions.value = clientsData.map((client) => ({
          value: client.id,
          label: client.nomClient && client.prenomClient 
                ? `${client.nomClient} ${client.prenomClient}`
                : `${client.raisonSociale}`,
        }));
      } catch (err) {
        error(err.message);
      }
    };

    // Récupérer les données de la créance
    const getCreance = async (id: number) => {
      try {
        const response = await ApiService.get(`/creances/${id}`);
        const creanceData = response.data.data;

        if (!creanceData) {
          throw new Error('Aucune donnée de créance reçue');
        }

        // Pré-remplir les champs du formulaire
        creanceForm.value = {
          id: creanceData.id,
          dateCreance: creanceData.dateCreance ? creanceData.dateCreance.split('T')[0] : getCurrentDate(),
          client: creanceData.client_id,
          montant: creanceData.montant,
          nbreEcheance: creanceData.nbreEcheance,
          motifCreance: creanceData.motifCreance,
        };

        // Pré-remplir les échéances
        if (creanceData.echeances && creanceData.echeances.length > 0) {
          echeances.length = 0; // Vider les échéances par défaut
          creanceData.echeances.forEach((echeance) => {
            echeances.push({
              dateEcheance: echeance.dateEcheance ? echeance.dateEcheance.split('T')[0] : "",
              montant: echeance.montant,
            });
          });
        }

        // Mettre à jour les variables réactives
        client.value = creanceData.client_id;
        montant.value = creanceData.montant;
        nbreEcheance.value = creanceData.nbreEcheance;
      } catch (err) {
        error(err.message || 'Une erreur est survenue lors de la récupération de la créance');
      }
    };

    // Soumettre les modifications de la créance
    const editCreance = async (values, { resetForm }) => {
      const creanceData = {
        id: values.id,
        dateCreance: values.dateCreance,
        client_id: values.client,
        montant: values.montant,
        nbreEcheance: values.nbreEcheance,
        motifCreance: values.motifCreance,
        echeances: echeances.map((echeance) => ({
          dateEcheance: echeance.dateEcheance,
          montant: echeance.montant,
        })),
      };

      try {
        const response = await ApiService.put(`/creances/${values.id}`, creanceData);
        if (response.data.code === 200) {
          success(response.data.message);
          resetForm();
          router.push({ name: "ListeCreance" });
        }
      } catch (err) {
        error(err.message || 'Une erreur est survenue lors de la mise à jour de la créance');
      }
    };

    // Charger les données au montage
    onMounted(() => {
      getAllClients();
      if (route.params.id) {
        getCreance(parseInt(route.params.id as string));
      }
    });

    return {
      creanceSchema,
      editCreance,
      getCurrentDate,
      clientOptions,
      client,
      montant,
      nbreEcheance,
      echeances,
      removeRowEcheance,
      valideteRowEcheance,
      isDisable,
      creanceForm,
    };
  },
});
</script>

<style scoped>
.error {
  color: red;
}
</style>